import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useSelector } from 'statux'

import Badge from '../../../../components/Badge/Badge'
import Image from '../../../../components/Image/Image'
import Table from '../../../../components/Table/Table'

import { getCssVar } from '../../../../utils/css'
import { graphqlClient, gql } from '../../../../utils/gql'
import { getInitials } from '../../../../utils/strings'

import authProvider from '../../../../utils/auth-provider'

export default function DashboardHomeEbpcReviewer (props = {
    className: null
}) {
    const userId = (authProvider.getIdentity() || {}).id

    const isEbpcReviewer = authProvider.getDefaultRole() === 'ebpc_reviewer'

    if (!isEbpcReviewer)
        return null

    const history = useHistory()

    const {
        ebpcContest,
        ebpcReviewsOpen,
        ebpcReviewsEndDateStr
    } = useSelector()

    const ebpcReviewsEndDate = ebpcReviewsEndDateStr
        && new Date(ebpcReviewsEndDateStr)

    if (ebpcReviewsEndDate)
        ebpcReviewsEndDate
            .setDate(ebpcReviewsEndDate.getDate() + 1)

    const ebpcReviewsClosedConstestOpen = ebpcContest
        && ebpcReviewsEndDate
        && ebpcReviewsEndDate.getTime()
            < (new Date()).getTime()

    console.log(ebpcReviewsEndDate)

    const [reviews, setReviews] = useState(
        ebpcReviewsOpen
            ? (history.location.state || {}).ebpcReviews
                || null
            : [])

    useEffect(async () => {
        if (!userId
                || !(ebpcReviewsOpen
                    || ebpcReviewsClosedConstestOpen))
            return !ebpcReviewsOpen
                && setReviews([])

        const query = await graphqlClient
            .request(gql`
                query {
                    ebpc_reviews (
                        where: {
                            ebpc_reviewer_id: {
                                _eq: "${userId}"
                            },
                            ebpc_application: {
                                ebpc_contest_id: {
                                    _eq: ${ebpcContest.id}
                                },
                                submitted_at: {
                                    _is_null: false
                                }
                            }
                        },
                        order_by: {
                            ebpc_application_id: asc
                        }
                    ) {
                        approved
                        created_at
                        updated_at
                        ebpc_application {
                            id
                            data
                            venture: data(path: "aboutYourVenture.ventureName")
                            submitted_at
                            ebpc_review_approved
                            profile {
                                company
                                user {
                                    id
                                    avatar_url
                                    display_name
                                }
                            }
                        }
                    }
                }
            `, {}, {
                headers: {
                    'x-hasura-role': 'ebpc_reviewer'
                }
            })
            .then(obj => obj.ebpc_reviews
                .filter(_obj => _obj.ebpc_application.ebpc_review_approved
                    === _obj.approved)
                .map((_obj) => {
                    _obj.status = 'Not started'
                    _obj.statusType = ''

                    if (_obj.approved) {
                        _obj.status = 'Advance'
                        _obj.statusType = 'success'
                    }

                    if (_obj.approved === null
                            && _obj.created_at !== _obj.updated_at) {
                        _obj.status = 'Undecided'
                        _obj.statusType = 'warning'
                    }

                    if (_obj.approved === false) {
                        _obj.status = 'Do not advance'
                        _obj.statusType = 'danger'
                    }

                    _obj.plan = `24-${`${_obj.ebpc_application.id}`
                        .padStart(4, '0')}`

                    _obj.venture = _obj.ebpc_application.venture
                        || _obj.ebpc_application.profile.company

                    _obj.applicant = _obj.ebpc_application.profile.user

                    return _obj
                }))
            .catch((err) => {
                console.warn(err)
                return []
            })

        if (JSON.stringify(reviews)
                === JSON.stringify(query))
            return

        setReviews(query)

        history.replace(
            `${history.location.pathname}${history.location.search}`,
            Object.assign(history.location.state || {}, {
                ebpcReviews: query
            }))
    }, [])

    if (reviews === null)
        return null

    const isReviews = Boolean(reviews.length)

    const isSubmitted = isReviews
        && reviews.length
            === reviews
                .filter(obj => obj.created_at !== obj.updated_at)
                .length

    let reviewsHeading = ''

    let reviewsText = ''

    if (isReviews) {
        reviewsHeading = (isSubmitted
                || ebpcReviewsClosedConstestOpen)
            ? (isSubmitted
                ? 'You\'ve completed and submitted your reviews'
                : 'Reviews are not open at this time')
            : 'Applications for your review'

        reviewsText = (isSubmitted
                || ebpcReviewsClosedConstestOpen)
            ? 'Thank you for your support!'
            : (ebpcReviewsOpen
                ? `Please complete all reviews${
                        ebpcReviewsEndDateStr
                            ? ` by ${ebpcReviewsEndDateStr}.`
                            : ''}`
                : '')
    }

    if (!isReviews) {
        reviewsHeading = ebpcReviewsOpen
                || (ebpcContest
                    && !ebpcReviewsClosedConstestOpen)
            ? 'Application assignments coming soon'
            : 'The competition is not open at this time'

        reviewsText = ebpcReviewsOpen
                || (ebpcContest
                    && !ebpcReviewsClosedConstestOpen)
            ? 'We\'re working to complete the application period, then validate and assign applications to reviewers. We\'ll let you know when we\'re ready for you to start reviewing applications. Thank you for your patience.'
            : 'Thank you for checking in; we\'ll be in touch.'
    }

    return (
        <section className="dashboard-home-ebpc-reviews card card-offscreen-x-lg-down margin-1-b margin-3-b-lg-up">
            <div className="row flex-justify-content-space-between">
                <div
                    className={`col${isReviews
                        ? ' col-12-md-down pad-4-r-md-up'
                        : ''}`}
                >
                    {reviewsHeading
                        && <h2 className="heading-5">{reviewsHeading}</h2>}

                    {reviewsText
                        && <p className="body-4">{reviewsText}</p>}
                </div>
                {isReviews
                    && (
                        <>
                            {!isSubmitted
                                && ebpcReviewsOpen
                                && (
                                    <div className="col-auto margin-t-md-down">
                                        <Link
                                            to={`/dashboard/ebpc/applications/${
                                                ((reviews[0] || {})
                                                    .applicant || {})
                                                    .id}`}
                                            className="btn btn-secondary"
                                        >
                                            Review applications
                                        </Link>
                                    </div>)}
                            <div className="dashboard-ebpc-applications col-12 margin-3-t">
                                <Table
                                    style={{
                                        color: getCssVar('--navy')
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th>
                                                <span>Plan</span>
                                                <span className="display-none-sm-down"> number</span>
                                                <span className="display-none-sm-up" aria-label="number"> #</span>
                                            </th>
                                            <th>Venture name</th>
                                            <th>Applicant name</th>
                                            <th>
                                                <span
                                                    style={{
                                                        paddingLeft: 15
                                                    }}
                                                >
                                                    Status
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reviews
                                            .map((obj, idx) => (
                                                <tr
                                                    key={`dashboard-home-ebpc-reviews-${idx}`}
                                                >
                                                    <td><span>{obj.plan}</span></td>
                                                    <td
                                                        className="table-col-venture"
                                                    >
                                                        <Link
                                                            to={`/dashboard/ebpc/applications/${obj.applicant.id}`}
                                                            title="View application"
                                                        >
                                                            <span>{obj.venture}</span>
                                                        </Link>
                                                    </td>
                                                    <td
                                                        className="table-col-applicant"
                                                    >
                                                        <Link
                                                            to={`/dashboard/profiles/${obj.applicant.id}`}
                                                            title={`View profile of ${obj.applicant.display_name}`}
                                                            aria-label={obj.applicant.display_name}
                                                        >
                                                            <span className="avatar avatar-sm">
                                                                <Image
                                                                    src={!(obj.applicant.avatar_url || '')
                                                                        .match(/gravatar\.com/)
                                                                        ? obj.applicant.avatar_url
                                                                        : null}
                                                                    textFallback={getInitials(obj.applicant.display_name)}
                                                                    data-object-fit="cover"
                                                                />
                                                            </span>
                                                            <span>{obj.applicant.display_name}</span>
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <Badge
                                                            type={obj.statusType}
                                                        >
                                                            {obj.status}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>
                            </div>
                        </>)}
            </div>
        </section>
    )
}
